export default "__VITE_ASSET__CKjw_Lb6__"